module.exports = __webpack_public_path__ + "94ac565fd98b52020b5ef0845672176f.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/company/banner.jpg
// module id = ./assets/images/company/banner.jpg
// module chunks = 0